exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n    ////////////////////////////////////////////////\n    //            FONT - COLOR - BACKGROUNDS MIXERS            //\n    ////////////////////////////////////////////////\n\n */\n:root {\n  --purple:#640a92;\n  --orchid:#bf4cbf;\n  --white:#fff;\n  --grey:#4a4a4a;\n  --sub-grey:#d8d8d8;\n  --dark:#1a1a1a;\n  --green:#3dadad;\n  --nvidia-green:#76b900;\n}\n.holiday-savings-msg {\n  text-align: left;\n}\n.holiday-savings-msg p {\n  color: #640a92;\n  margin: 0;\n}\n.holiday-savings-msg .highlight {\n  color: #640a92;\n}\n.holiday-savings-msg .bold {\n  font-weight: bold;\n}", ""]);

// exports
